import type { ExceptionField } from '@/api/cockpit';

export function resolveMatchedFieldValue(
  field: ExceptionField,
  fields: Record<string, string>,
): string {
  return fields[field.key] ?? field.matchedValue ?? field.value;
}
